export const formatOpeningHoursForSubmit = (openingHours: any[]) => {
    console.log(openingHours)
  return openingHours.map((item) => {
    const formatTime = (time: any | null) => {
      if (!time) return null; // قيمة افتراضية عند null

      let hour = parseInt(time.hour, 10);
      const minute = time.minute.padStart(2, "0");

      // تحويل AM/PM إلى 24 ساعة
      if (time.period === "PM" && hour < 12) hour += 12;
      if (time.period === "AM" && hour === 12) hour = 0;

      return `${hour.toString().padStart(2, "0")}:${minute}`;
    };

    return {
      day: item.day,
      openTime: formatTime(item.openTime),
      closeTime: formatTime(item.closeTime),
      id: item.id,
    };
  });
};


export const parseOpeningHoursFromAPI = (openingHours: any[]) => {
  console.log(openingHours);
  
  return openingHours.map((item) => {
    const parseTime = (timeStr: string | null) => {
      if (!timeStr) return null; // قيمة افتراضية

      const [hStr, mStr] = timeStr.split(":");
      let hour = parseInt(hStr, 10);
      const minute = mStr;
      const period = hour >= 12 ? "PM" : "AM";

      if (hour > 12) hour -= 12;
      if (hour === 0) hour = 12;

      return { hour: hour.toString().padStart(2, "0"), minute, period };
    };

    return {
      ...item,
      openTime: parseTime(item.openTime),
      closeTime: parseTime(item.closeTime),
    };
  });
};

